import React, { useEffect, useMemo, useRef } from 'react';
import TextBox from 'devextreme-react/text-box';
import { AntLocalization } from 'ante-react-kit';
import ServePlaceCard from './ServePlaceCard';

const SEARCH_INPUT_ATTR = { autoFocus: true };

const STATUS_GROUP = [
    { value: 'Available', label: { vi: 'Khả dụng', en: 'Available' } },
    { value: 'Serving', label: '' },
    { value: 'Reserved', label: { vi: 'Đã đặt', en: 'Reserved' } },
    { value: 'Unavailable', label: { vi: 'Không khả dụng', en: 'Unavailable' } }
];

function ChipsRow({ items, activeSet, onToggle, groupKey }) {
    if (!items || items.length === 0) return null;
    return (
        <div className="spk-chips__row">
            {items.map((it) => {
                const isOn = activeSet && activeSet.has(it.value);
                const text = typeof it.label === 'string'
                    ? it.label
                    : (it.label ? AntLocalization.translateText(it.label) : it.value);
                return (
                    <span
                        key={String(it.value)}
                        className={'spk-chip' + (isOn ? ' spk-chip--on' : '')}
                        onClick={() => onToggle(groupKey, it.value)}
                    >
                        {text}{typeof it.count === 'number' ? ' (' + it.count + ')' : ''}
                    </span>
                );
            })}
        </div>
    );
}

export default function SearchView({
    query, onQueryChange, rows, loading,
    activeFilters, onToggleFilter, onPickCard, previewRow,
    filterSources, totalCount, allCount
}) {
    const searchBoxRef = useRef(null);

    useEffect(() => {
        const inst = searchBoxRef.current && searchBoxRef.current.instance;
        if (inst) {
            const t = setTimeout(() => { try { inst.focus(); } catch (e) { /* ignore */ } }, 50);
            return () => clearTimeout(t);
        }
    }, []);

    const typeItems = useMemo(
        () => (filterSources.types || []).map((t) => ({ value: t.value, label: t.value, count: t.count })),
        [filterSources.types]
    );
    const tagItems = useMemo(
        () => (filterSources.tags || []).map((t) => ({ value: t, label:  t })),
        [filterSources.tags]
    );

    const empty = !loading && rows.length === 0;

    return (
        <div className="spk-shell">
            <div className="spk-search-header">
                {/* <div className="spk-search-row">
                    <TextBox
                        ref={searchBoxRef}
                        value={query}
                        valueChangeEvent="input keyup change"
                        onValueChanged={(e) => onQueryChange(e.value || '')}
                        placeholder={AntLocalization.translateText({ vi: 'Tìm theo tên bàn/phòng, loại, mô tả...', en: 'Search by name, type, description...' })}
                        showClearButton={true}
                        inputAttr={SEARCH_INPUT_ATTR}
                    />
                    <span className="spk-counter">
                        {totalCount}{allCount !== totalCount ? ' / ' + allCount : ''}
                    </span>
                </div> */}
                <div className="spk-chips">
                    {/* <ChipsRow items={STATUS_GROUP} activeSet={activeFilters.serve_status} onToggle={onToggleFilter} groupKey="serve_status" /> */}
                    {/* <ChipsRow items={typeItems} activeSet={activeFilters.serve_place_type} onToggle={onToggleFilter} groupKey="serve_place_type" /> */}
                    <ChipsRow items={tagItems} activeSet={activeFilters.serve_place_tags} onToggle={onToggleFilter} groupKey="serve_place_tags" />
                </div>
            </div>
            <div className="spk-list">
                {loading && rows.length === 0 && (
                    <>
                        <div className="spk-skeleton" /><div className="spk-skeleton" />
                        <div className="spk-skeleton" /><div className="spk-skeleton" />
                    </>
                )}
                {empty && (
                    <div className="spk-empty">
                        {AntLocalization.translateText({ vi: 'Không có bàn/phòng phù hợp', en: 'No matching place' })}
                    </div>
                )}
                {rows.map((r) => (
                    <ServePlaceCard
                        key={r.id || r.serve_place_code}
                        row={r}
                        isActive={previewRow && previewRow.id === r.id}
                        onClick={onPickCard}
                    />
                ))}
            </div>
        </div>
    );
}
